'use client'

import PlanCards from '@/components/access/PlanCards'
import { STORY_LIMITS } from '@/constants/plans'
import { track } from '@/lib/tracking'
import { useEffect } from 'react'

// Where a story stops when a reader has used this month's allowance (free
// and paid tiers, 2026-10-19). Both plans side by side since 2026-11-01
// (PlanCards): a guest is led to the free plan (the newsletter and 10
// stories a month), a free subscriber to Unlimited, with the date their
// free stories come back under their own plan.
export default function StoryLimit({ tier, limit, resets, slug }) {
  useEffect(() => {
    track('story_limit_reached', { reader_tier: tier, story_slug: slug })
  }, [tier, slug])

  const guest = tier === 'guest'
  return (
    <section>
      <h2 className="font-serif text-2xl font-medium leading-snug text-foreground">
        {guest
          ? `You've read ${limit} free stories this month`
          : `You've read your ${limit} free stories this month`}
      </h2>
      <p className="mb-5 mt-2 font-sans text-[15px] leading-relaxed text-foreground/80">
        {guest
          ? `Subscribe free to keep reading: ${STORY_LIMITS.free} stories a month, plus the daily newsletter.`
          : 'Go unlimited to keep reading today. The newsletter stays free either way.'}
      </p>
      <PlanCards
        tier={tier}
        surface="story_limit"
        compact
        note={resets ? `Your free stories come back on ${resets}.` : null}
      />
    </section>
  )
}
